import { Price } from "../../../redux/user/userSlice";
import axios from "../../publicApi";

export const fetchPrices = (): Promise<Price[]> => {
  return axios.get("/payments/prices").then((response) => {
    return response.data;
  });
};
